import React, { useEffect } from 'react';
import { useSelectInput, SelectOption } from './hooks/useSelectInput';
import { catalogClient } from '../services/grpc';
import { AutoReq } from '../generated/catalog_pb';
import '../styles/select-input.css';

const loadMarks = async (query: string): Promise<SelectOption[]> => {
  const req = new AutoReq();
  req.setName(query);

  return new Promise((resolve, reject) => {
    catalogClient.autoRequest(req, {}, (err, response) => {
      if (err) {
        reject(err);
        return;
      }

      const items =
        response?.getListList().map((item) => ({
          id: item.getAutoId(),
          label: item.getName(),
        })) || [];

      resolve(items);
    });
  });
};

interface MarkSelectProps {
  onMarkSelect: (mark: SelectOption | null) => void;
  inputId?: string;
  placeholder?: string;
}

const MarkSelect: React.FC<MarkSelectProps> = ({
  onMarkSelect,
  inputId,
  placeholder = 'Выберите марку...',
}) => {
  const {
    inputValue,
    setInputValue,
    selectedOption,
    options,
    isLoading,
    isOpen,
    handleSelect,
    handleBlur,
    openDropdown,
    loadCurrentOptions,
  } = useSelectInput<SelectOption>({
    loadOptions: loadMarks,
    debounceMs: 300,
    minQueryLength: 0,
  });

  useEffect(() => {
    onMarkSelect(selectedOption);
  }, [selectedOption, onMarkSelect]);

  const shouldOpenOnFocus = options.length > 0;

  return (
    <div className="select-input" onBlur={handleBlur}>
      <input
        id={inputId}
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        onFocus={() => {
          if (inputValue === '') {
            if (options.length === 0) {
              loadCurrentOptions();
            } else {
              openDropdown();
            }
          } else if (shouldOpenOnFocus) {
            openDropdown();
          }
        }}
        className="select-input__field"
        autoComplete="off"
      />

      {isOpen && isLoading && (
        <div className="select-input__status select-input__status--loading">
          Загрузка...
        </div>
      )}

      {isOpen && !isLoading && options.length > 0 && (
        <ul className="select-input__dropdown">
          {options.map((option) => (
            <li
              key={option.id}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => handleSelect(option)}
              className="select-input__option"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}

      {isOpen && !isLoading && options.length === 0 && (
        <div className="select-input__status">Ничего не найдено</div>
      )}
    </div>
  );
};

export default MarkSelect;